export default {
  'menu.visualization.multiDimensionDataAnalysis': 'Order Analysis',
  'multiDAnalysis.card.title.orderAnalytics': 'Order Analysis',
  'multiDAnalysis.orderAnalytics.merchantId': 'merchantId',
  'multiDAnalysis.orderAnalytics.merchantIdPlaceholder': 'Merchant ID',
  'multiDAnalysis.orderAnalytics.shopId': 'shopId',
  'multiDAnalysis.orderAnalytics.shopIdPlaceholder': 'Single shop ID',
  'multiDAnalysis.orderAnalytics.shopIds': 'shopIds',
  'multiDAnalysis.orderAnalytics.shopIdsPlaceholder': 'Shop IDs (comma separated)',
  'multiDAnalysis.orderAnalytics.start': 'start',
  'multiDAnalysis.orderAnalytics.end': 'end',
  'multiDAnalysis.orderAnalytics.tzOffsetMinutes': 'tzOffsetMinutes',
  'multiDAnalysis.orderAnalytics.groupBy': 'groupBy',
  'multiDAnalysis.orderAnalytics.query': 'Query',
  'multiDAnalysis.orderAnalytics.reset': 'Reset',
};
